import RedirectLayout from './RedirectLayout';
import redirect from './redirect';

export default function redirectOther(url) {
  const Redirect = redirect(url, { statusCode: 303 });

  return (
    <RedirectLayout>
      <Redirect />
    </RedirectLayout>
  );
}
